import HandleCloseAlert from '../functions/close-alert';
export default function initializeAjaxForms() {
    HandleCloseAlert();
    const submitCloseAlert = () => {
        if (document.querySelector('.form-alert')) {
            document.querySelector('.form-alert').remove();
        }
    };

    const handleLoginSubmit = async event => {
        event.preventDefault();
        submitCloseAlert();
        const { url } = ajax;
        const form = event.target;
        const formData = new FormData(form);
        formData.append('action', 'handle_login');
        const submitButton = form.querySelector('button[type="submit"]');
        submitButton.classList.add('--loading');

        try {
            const req = await fetch(url, {
                method: 'POST',
                body: formData,
            });
            const response = await req.json();

            if (response.success) {
                if (response.data.requires_2fa) {
                    submitButton.classList.remove('--loading');

                    const codeFieldHtml = `
                        <div class="form-alert --info" style="margin-bottom: 20px; color:#61626b'">
                            ${response.data.message}
                        </div>
                        <input class="form__input" placeholder="Wpisz kod z emaila" type="text" name="email_code" id="emailCode" required autocomplete="one-time-code" inputmode="numeric" pattern="[0-9]{6}" maxlength="6">
                        <input type="hidden" name="wp_auth_id" value="${response.data.wp_auth_id}">
                        <input type="hidden" name="wp_auth_nonce" value="${response.data.wp_auth_nonce}">
                    `;

                    const passwordField = form.querySelector('#userPassword');
                    if (passwordField) {
                        const oldCodeField = form.querySelector('#emailCode');
                        if (oldCodeField) {
                            oldCodeField.closest('.form__input').remove();
                        }

                        passwordField.insertAdjacentHTML(
                            'afterend',
                            codeFieldHtml
                        );

                        submitButton.textContent = 'Zweryfikuj kod';

                        setTimeout(() => {
                            document.getElementById('emailCode')?.focus();
                        }, 100);
                    }

                    HandleCloseAlert();
                    return;
                }

                if (response.data.redirect_url) {
                    window.location.href = response.data.redirect_url;
                } else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            } else {
                submitButton.classList.remove('--loading');
                document
                    .querySelector('.form__submit')
                    .insertAdjacentHTML('afterbegin', `${response.data.html}`);
            }
        } catch (error) {
            console.error('Error:', error);
            submitButton.classList.remove('--loading');
        } finally {
            HandleCloseAlert();
        }
    };

    const handleFormSubmit = async (event, action, reload = true) => {
        event.preventDefault();
        submitCloseAlert();
        const { url } = ajax;
        const form = event.target;
        const formData = new FormData(form);
        formData.append('action', action);
        const submitButton = form.querySelector('button[type="submit"]');
        submitButton.classList.add('--loading');
        try {
            const req = await fetch(url, {
                method: 'POST',
                body: formData,
            });
            const response = await req.json();
            if (response.success) {
                if (response.data.redirect_url) {
                    window.location.href = response.data.redirect_url;
                } else if (reload) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    submitButton.classList.remove('--loading');
                    submitButton.classList.add('--disabled');
                    submitButton.disabled = true;
                    document.querySelector('.form__submit').insertAdjacentHTML(
                        'afterbegin',
                        `
                        ${response.data.html}
                    `
                    );
                }
            } else {
                submitButton.classList.remove('--loading');
                document
                    .querySelector('.form__submit')
                    .insertAdjacentHTML('afterbegin', `${response.data.html}`);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            submitButton.classList.remove('--loading');
            HandleCloseAlert();
        }
    };

    document
        .getElementById('loginForm')
        ?.addEventListener('submit', handleLoginSubmit);

    document
        .getElementById('registerForm')
        ?.addEventListener('submit', event => {
            handleFormSubmit(event, 'handle_register', false);
        });

    document
        .getElementById('registerWithCode')
        ?.addEventListener('submit', event => {
            handleFormSubmit(event, 'handle_invite_code');
        });

    document
        .getElementById('resetPassword')
        ?.addEventListener('submit', event => {
            handleFormSubmit(event, 'handle_reset_password', false);
        });
}
